import api from ".";

export const getInvoices = (params) => api.get("/invoices", { params });

export const getArchivedInvoices = (params) => api.get("/invoices/archived", { params });

export const archiveInvoice = ({ uuid }) => api.patch(`/invoices/${uuid}/archive`);

export const markInvoiceAsPaid = ({ uuid }) => api.put(`/invoices/${uuid}/mark-as-paid`);

export const unArchiveInvoice = ({ uuid }) => api.patch(`/invoices/${uuid}/unarchive`);

export const createInvoice = (data) => api.post("/invoices/store", data);

export const getInvoiceDetails = (uuid) => api.get(`/invoices/${uuid}/view`);

export const sendInvoiceReminder = ({ uuid }) => api.post(`/invoices/${uuid}/send-reminder`);

export const getInvoiceGroups = (params) => api.get(`/groups`, { params });

export const createInvoiceGroup = (data) => api.post(`/groups`, data);

export const updateInvoiceGroup = ({ uuid, ...data }) => api.put(`/groups/${uuid}`, data);

export const deleteInvoiceGroup = ({ uuid }) => api.delete(`/groups/${uuid}`);

export const getInvoiceGroupMembers = ({ uuid }) => api.get(`/groups/${uuid}/members`);

export const removeInvoiceGroupMembers = ({ uuid, data }) => api.post(`/groups/${uuid}/remove-subaccount`, data);

export const addInvoiceGroupMembers = ({ uuid, data }) => api.post(`/groups/${uuid}/add-subaccount`, data);
